import { Field } from "formik"

function Input({ type, name, placeholder, component, className }) {
    return (
        <Field
            type={type}
            name={name}
            component={component}
            placeholder={placeholder}
            autoComplete="off"
            className={"w-full outline-none border-b border-text bg-transparent py-2 mt-4 text-base" + className} />
    )
}

export default Input